"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const react_1 = __importStar(require("react"));
const bind_1 = __importDefault(require("classnames/bind"));
const ityped_1 = require("ityped");
const Fade_1 = __importDefault(require("react-reveal/Fade"));
const text_module_scss_1 = __importDefault(require("./text.module.scss"));
class Text extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            className: "",
            reveal: false,
            style: {}
        };
        var cx = bind_1.default.bind(text_module_scss_1.default);
        this.state.className = text_module_scss_1.default.text + " ";
        this.state.className += props.hasOwnProperty("type") ? cx(props.type.split(" ")) : text_module_scss_1.default.normal;
        if (this.props.hasOwnProperty("type") && this.props.type.indexOf("gradient") > -1) {
            this.state.style.backgroundImage = "linear-gradient(90deg, " + props.from + " 0%, " + props.to + " 100%)";
        }
        if (this.props.hasOwnProperty("reveal")) {
            this.state.reveal = this.props.reveal;
        }
        this.text = (0, react_1.createRef)();
    }
    getSize() {
        if (this.props.hasOwnProperty("type")) {
            if (this.props.type.indexOf("h1") > -1) {
                return "h1";
            }
            if (this.props.type.indexOf("h2") > -1) {
                return "h2";
            }
            if (this.props.type.indexOf("h3") > -1) {
                return "h3";
            }
        }
        return "normal";
    }
    componentDidMount() {
        if (this.props.hasOwnProperty("animated") && this.props.animated) {
            var parent = this.text.current.parentElement;
            (0, ityped_1.init)(this.text.current, { showCursor: true, strings: this.props.strings, typeSpeed: 150, backSpeed: 50, backDelay: 500 });
            parent.getElementsByClassName("ityped-cursor")[0].classList.add(text_module_scss_1.default.blinking);
            parent.getElementsByClassName("ityped-cursor")[0].classList.add(text_module_scss_1.default[this.getSize()]);
            parent.getElementsByClassName("ityped-cursor")[0].style.color = this.props.cursorColor;
        }
    }
    render() {
        var customStyle = this.props.hasOwnProperty("style") ? this.props.style : {};
        if (this.state.reveal) {
            var bottom = this.props.hasOwnProperty("bottom") ? this.props.bottom : true;
            return react_1.default.createElement(Fade_1.default, { bottom: bottom, top: !bottom },
                react_1.default.createElement("span", { className: this.state.className, style: Object.assign(Object.assign({}, this.state.style), customStyle), ref: this.text }, this.props.children));
        }
        return react_1.default.createElement("span", { className: this.state.className, style: Object.assign(Object.assign({}, this.state.style), customStyle), ref: this.text }, this.props.children);
    }
}
exports.Text = Text;
//# sourceMappingURL=text.js.map